import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryActionOptions = createRoutine(
  'FETCH_INVENTORY_ACTION_OPTIONS'
);

export const fetchInventoryAuditLogsForItem = createRoutine(
  'FETCH_INVENTORY_AUDIT_LOGS_FOR_ITEM'
);
